export default __webpack_public_path__ + "static/media/particles-web-theme4.f19a4025.svg";